import { render } from "./AuditLogsSidebar.vue?vue&type=template&id=11028a91&ts=true"
import script from "./AuditLogsSidebar.vue?vue&type=script&lang=ts"
export * from "./AuditLogsSidebar.vue?vue&type=script&lang=ts"

import "./AuditLogsSidebar.vue?vue&type=style&index=0&id=11028a91&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__